import React from "react";
import { NavLink } from "react-router-dom";

import {
  Phone,
  Mail,
  MapPin,
  ChevronRight,
} from "lucide-react";

import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

import "bootstrap/dist/css/bootstrap.min.css";

function Footer() {
  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const links = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },

    { to: "/contact", label: "Contact" },
    { to: "/pricing", label: "Pricing" },
   
  ];

  const socialStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: "#fff",
    color: "#0b1018",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    transition: "all 0.3s ease",
  };

  return (
    <footer
      style={{
        background: "#0b1018",
        color: "#fff",
        fontFamily: "'Poppins', sans-serif",
        padding: "60px 0 20px",
      }}
    >
      <div className="container">

        {/* ================= MAIN FOOTER ================= */}

        <div className="row gy-4">

          {/* ================= ABOUT ================= */}

          <div className="col-lg-4 col-md-6">

            <p
              style={{
                color: "#d6d6d6",
                lineHeight: "1.8",
                fontSize: "15px",
                maxWidth: "320px",
              }}
            >
           Simplify your billing, manage your business, and stay in control with smart, reliable billing solutions.
            </p>

            {/*  SOCIAL ICONS */}

            <div className="d-flex gap-3 mt-4">

              {/* YouTube */}

              <a
                // href="/"
                style={socialStyle}
                aria-label="YouTube"
              >
                <FaYoutube size={19} />
              </a>

              {/* Facebook */}

              <a
                // href="/"
                style={socialStyle}
                aria-label="Facebook"
              >
                <FaFacebook size={19} />
              </a>

              {/* Instagram */}

              <a
                // href="/"
                style={socialStyle}
                aria-label="Instagram"
              >
                <FaInstagram size={19} />
              </a>

            </div>
          </div>


        

          <div className="col-lg-4 col-md-6">

            <h5
              style={{
                fontSize: "20px",
                fontWeight: "700",
                marginBottom: "20px",
                letterSpacing: "0.5px",
              }}
            >
              ADDRESS
            </h5>

            

            <p
              className="mb-3 d-flex align-items-center"
              style={{
                color: "#d6d6d6",
              }}
            >
              <Phone
                size={17}
                className="me-2 flex-shrink-0"
              />

              <span>8707510135</span>
            </p>



            <p
              className="mb-3 d-flex align-items-center"
              style={{
                color: "#d6d6d6",
              }}
            >
              <Mail
                size={17}
                className="me-2 flex-shrink-0"
              />

              <span>dectwin@gmail.com</span>
            </p>




            <p
              style={{
                color: "#d6d6d6",
                lineHeight: "1.8",
                maxWidth: "330px",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <MapPin
                size={17}
                className="me-2 mt-1 flex-shrink-0"
              />

              <span>
                
               85/47, CY Chintamani Rd, Darbhanga Colony,
                <br />
        George Town, Prayagraj, Uttar Pradesh 211002
              </span>
            </p>

          </div>



          <div className="col-lg-4 col-md-12">

            <h5
              style={{
                fontSize: "20px",
                fontWeight: "700",
                marginBottom: "20px",
                letterSpacing: "0.5px",
              }}
            >
              QUICK LINKS
            </h5>

            {links.map((link, index) => (
              <NavLink
                key={index}
                to={link.to}
                onClick={handleScrollTop}
                className="d-flex align-items-center text-decoration-none mb-2"
                style={{
                  color: "#d6d6d6",
                  fontSize: "15px",
                  transition: "all 0.25s ease",
                }}
              >
                <ChevronRight
                  size={14}
                  style={{
                    marginRight: "8px",
                    flexShrink: 0,
                  }}
                />

                <span>{link.label}</span>
              </NavLink>
            ))}

          </div>

        </div>


   

     <hr
  style={{
    borderColor: "#2b2f36",
    margin: "40px 0 20px",
  }}
/>

<div className="d-flex justify-content-center align-items-center text-center">
  <p
    style={{
      color: "#d6d6d6",
      marginBottom: "0",
      fontSize: "14px",
    }}
  >
    © 2026 Dectwin Billing, all rights reserved{" "}
    
    <a
      href="https://dectwinservices.com/"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#d6d6d6",
        textDecoration: "none",
        cursor: "pointer",
        marginLeft: "5px",
      }}
    >
      Dectwin Services
    </a>
  </p>
</div>



      </div>
    </footer>
  );

}


export default Footer;